
import { useState } from "react";
import { 
  Sheet, 
  SheetContent, 
  SheetTrigger 
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { LayoutPanelLeft } from "lucide-react";
import { SidebarLogo } from "./SidebarLogo";
import { SidebarNavigation } from "./SidebarNavigation";

export const MobileSidebar = () => {
  const [expanded, setExpanded] = useState(false);
  
  const closeSidebar = () => {
    setExpanded(false);
  };

  return (
    <Sheet open={expanded} onOpenChange={setExpanded}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="p-0 data-[state=open]:bg-secondary"
        >
          <LayoutPanelLeft className="h-4 w-4" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-64 p-0">
        <div className="flex flex-col h-full">
          <SidebarLogo expanded={true} />
          <SidebarNavigation expanded={true} closeSidebar={closeSidebar} />
        </div>
      </SheetContent>
    </Sheet>
  );
};
